import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RemindersBase from 'Components/AdvisorApp/Viewport/TodayDashboard/RemindersBase';
import LayoutItem from '../LayoutItem';

const styles = () => ({
  root: {
    height: '100%',
    position: 'relative',
  },
  reminderLayout: {
    height: '95%',
  },
});

const Reminders = ({
  className,
  classes,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <LayoutItem className={classes.reminderLayout} title="Reminders" variant="green" onChevronClick={() => {}}>
        <RemindersBase />
      </LayoutItem>
    </div>
  );
};

Reminders.defaultProps = {
  className: '',
};

Reminders.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Reminders);
